module.exports = __webpack_public_path__ + "img/ics_o_filter_red.91d968d9.svg";